import React, { useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { flattenRoutes } from './utilities';
import ThemeRoutes from '../routes/Router';
import publicRoutes from '../routes/PublicRoutes';
import authRoutes from '../routes/AuthRoutes';
import deviceDetailsRoutes from '../routes/DeviceDetailsRoutes';
import { useTheme } from '../hooks/useTheme';

const SEO = () => {
  const location = useLocation();
  const { theme } = useTheme();
  const routes = useMemo(
    () => flattenRoutes([...ThemeRoutes, ...authRoutes, ...publicRoutes, ...deviceDetailsRoutes]),
    [ThemeRoutes, authRoutes, publicRoutes, deviceDetailsRoutes]
  );
  const [routeName, setRouteName] = useState('');

  useEffect(() => {
    let routeName = routes.find(route => {
      return route.path.includes(location.pathname);
    })?.name;
    if (!routeName) {
      routeName = routes.find(route => {
        for (const param of [':id', ':sn', ':token', ':hash']) {
          if (route.path.includes(param)) {
            return location.pathname.includes(route.path.replace(param, ''));
          }
        }
        return null;
      })?.name;
    }
    setRouteName(routeName ? `${theme?.name} - ${routeName}` : `${theme?.name}`);
  }, [location, theme?.name]);

  if (!routeName) return <></>;
  return (
    <Helmet>
      <title>{routeName}</title>
    </Helmet>
  );
};

export default SEO;
